import React, { useState } from "react";
import { CircularProgress } from "@material-ui/core";
import styles from "./style.module.css";
import axios from "axios";
import OpenSnackbar from "src/Shared/OpenSnackbar";

const ResendPass = () => {
  const [value, setValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarDetails, setSnackbarDetails] = useState({
    message: "",
    type: "",
  });

  const handleSnackbarOpen = (message, type) => {
    let obj = {
      message,
      type,
    };
    setSnackbarDetails(obj);
    setSnackbarOpen(true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const emailRegex =
      /^([a-z\d\.-]+)@([a-z\d-]+)\.([a-z]{2,8})(\.[a-z]{2,8})?$/;
    if (!emailRegex.test(value)) {
      handleSnackbarOpen("Enter valid email", "errorDark");
    } else {
      setLoading(true);
      axios
        .post(process.env.REACT_APP_API_URL + `admin/resend/otp`, {
          email_id: value,
        })
        .then((res) => {
          setLoading(false);
          setValue("");
          handleSnackbarOpen("Temporary password sent", "successDark");
        })
        .catch((err) => {
          setLoading(false);
          handleSnackbarOpen("Please enter valid email", "errorDark");
          console.log(err);
        });
    }
  };
  if (loading) {
    return (
      <div
        style={{
          position: "absolute",
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <CircularProgress status={"loading"} />
      </div>
    );
  } else {
    return (
      <div className={styles.formDiv}>
        <form onSubmit={handleSubmit}>
          <h1 className={styles.head}>Resend Temporary Password</h1>
          <input
            type="text"
            placeholder="Enter email"
            className={styles.input}
            value={value}
            onChange={(e) => setValue(e.target.value)}
          />
          <button className={styles.button} type={"submit"}>
            Submit
          </button>
        </form>
        {snackbarOpen && (
          <OpenSnackbar
            message={snackbarDetails.message}
            type={snackbarDetails.type}
            open={snackbarOpen}
            setOpen={setSnackbarOpen}
            vertical="bottom"
            horizontal="center"
          />
        )}
      </div>
    );
  }
};

export default ResendPass;
